import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LeadAccountDailyStatsList from '../components/LeadAccountDailyStatsList';
import LeadAccountDailyStatsForm from '../components/LeadAccountDailyStatsForm';

const LeadAccountDailyStatsPage = () => {
    return (
        <Routes>
            <Route path="/" element={<LeadAccountDailyStatsList />} />

            <Route path="/edit/:id" element={<LeadAccountDailyStatsForm />} />
        </Routes>
    );
};

export default LeadAccountDailyStatsPage;